import { FC, memo } from 'react';
import NextImage from 'next/image';
import Button from '@material-ui/core/Button';

import {
  NotFound as UINotFound,
  Content,
  Title,
  Description,
} from './notFound.styles';
import { useNotFound } from './notFound.hook';

type Props = {
  title?: string;
};

export const NotFound: FC<Props> = memo(
  ({ title = `We didn't find any properties that match your criteria` }) => {
    const { isMaxRadius, incrementBy, onClick } = useNotFound();

    return (
      <UINotFound>
        <NextImage src="/svg/not-found.svg" width={82} height={89} />
        <Content>
          <Title variant="h2">{title}</Title>
          <Description variant="body2">
            Try increasing your search area or changing your search criteria to
            get more results
          </Description>
        </Content>
        <Button
          variant="contained"
          color="primary"
          size="large"
          disabled={isMaxRadius}
          onClick={onClick}
        >
          Widen my area by {incrementBy} miles
        </Button>
      </UINotFound>
    );
  }
);
